<template>
  <div class="auto-complete-container">
    <input
      class="default-input"
      :id="getDynamicNameItem('item-part-number')"
      v-model="query"
      type="text"
      :readonly="isItemSelected"
      placeholder="Part number"
      @input="visible = query.length"
    />
    <div v-show="visible">
      <div class="options">
        <ul v-show="results.length">
          <li
            v-for="item in results"
            :key="item.partNumber"
            @click="selectItem(item)"
          >
            {{ buildItemName(item) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ItemsService from "@/services/return-solicitation/items-service.js";
import { EventBus } from "@/eventHub";

export default {
  name: "AutoComplete",
  data: function() {
    return {
      partNumber: "",
      query: "",
      selectedItem: {},
      visible: false,
      items: [],
      isItemSelected: false
    };
  },
  props: {
    id: Number,
    invoiceIndex: Number,
    selectItemsList: Array
  },
  methods: {
    selectItem(item) {
      this.isItemSelected = true;
      this.visible = false;
      this.selectedItem = item;
      this.query = item.part_number;
      this.partNumber = item.part_number;
      this.$emit("itemSelected", this.selectedItem);
    },
    buildItemName(item) {
      return `${item.part_number} - ${item.name}`;
    },
    getDynamicNameItem(name) {
      return `${this.invoiceIndex + 1}-invoice-${name}-input-${this.id + 1}`;
    },
    async getAllItems() {
      const { data } = await ItemsService.getItemsList();
      this.items = data;
    }
  },
  computed: {
    results() {
      if (!this.query) {
        return [];
      }
      const items = this.items;
      return this.selectItemsList.filter(items =>
        items.part_number.toUpperCase().startsWith(this.query.toUpperCase())
      );
    }
  },
  created() {
    this.getAllItems();
    EventBus.$on("clearField", () => {
      this.partNumber = "";
      this.selectedItem = {};
      this.query = "";
      this.isItemSelected = false;
    });
  },
  mounted() {
    this.getAllItems();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.default-input {
  height: 25px;
  width: 48%;
  font-size: 14px;
  padding: 5px;
  border: 1px solid $grey3;
  margin-right: 18px;
  margin-top: 3px;
}

.options {
  margin-left: 5px;
  max-height: 200px;
  overflow-y: scroll;
  width: 50%;
  margin-top: 0;
}

ul {
  list-style: none;
  text-align: left;
  padding-left: 5px;
  margin-top: 3px;

  li {
    font-size: 12px;
    padding-bottom: 4px;
    padding-top: 4px;
    border-bottom: 1px solid #777777;

    &:hover {
      background-color: #ececec;
      cursor: default;
      background-clip: border-box;
    }
  }
}
</style>
